import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Input, Select, Icon } from 'antd'

import { languages } from '../../../../data/langauges'
// {languages[locale]['email']}
const useStyles = makeStyles(theme => ({
    content: {
        alignItems: 'center',
        justifyContent: 'center',
        float: 'left',
        width: '90%',
        marginTop: 10,
        marginBottom: 10
    },
    textField: {
        marginLeft: 25,
        marginRight: 30,
    },
    card: {
        borderRadius: 10,
        boxShadow: "0 3 10 0 rgba(0, 0, 0, 0.16)",
        backgroundColor: "#FFFFFF",
        borderLeft: "10px solid #65425f",
    },

}));

export default function StaticBankInfo(props) {
    const classes = useStyles();
    console.log('StaticBankInfo infooooooooo',props)
    const {locale} = props;
    return (
        <div className={classes.content}>
            <Card className={classes.card}>
                <CardContent>
                    <div className='font-large weight-500 text-purple-900'>
                        <span>{languages[locale]['bank_info']}</span>
                        <Icon type="edit" className='profile_card_icon' onClick={()=>props.changeCard("bank")} />
                    </div>
                    <div className='form-wrapper form-wrapper-card'>
                        <form className='form' >
                            <div className="row">
                                <div className='col-md-12 col-12'>
                                    <div className='form-input-wrapper font-medium text-purple-900'>
                                        <div className='input-wrapper'>
                                            <label>{languages[locale]['bank_name']} :</label>
                                            <span> {props.data.bankAccounts?props.data.bankAccounts.bank_name:''}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-12 col-12'>
                                    <div className='form-input-wrapper font-medium text-purple-900'>
                                        <div className='input-wrapper'>
                                            <label>{languages[locale]['account_num']} :</label>
                                            <span> {props.data.bankAccounts?props.data.bankAccounts.account_number:''}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-12 col-12'>
                                    <div className='form-input-wrapper font-medium text-purple-900'>
                                        <div className='input-wrapper'>
                                            <label>{languages[locale]['fast_code']} :</label>
                                            <span> {props.data.bankAccounts?props.data.bankAccounts.iban_number:''}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </CardContent>
            </Card>

        </div>


    );
}
